import { render, staticRenderFns } from "./foundation-year.vue?vue&type=template&id=b18d6912&"
import script from "./foundation-year.vue?vue&type=script&lang=js&"
export * from "./foundation-year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports